module.exports = __webpack_public_path__ + "4552b6af3571a11ac1da7d95a3fca91e.svg";